import React from "react"

import { useApiContext } from "~/api"
import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
import { Share } from "~/components/ContentEditable/components/Share/Share"
import { ContentEditable } from "~/components/ContentEditable/ContentEditable"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

export const Content: React.FC = () => {
  const { name, detailText } = useApiContext("/procurement/element")

  return (
    <div className={styles.Wrapper}>
      <Breadcrumbs />

      <div className="grid grid--col-12">
        <ContentEditable className={styles.ColLeft}>
          <div className={styles.Block}>
            <Heading like="h1">
              <Raw html={name} />
            </Heading>
            <p> </p>
            <p> </p>
            <Raw html={detailText} />
          </div>
          <div className={styles.Block}>
            <Share />
          </div>
        </ContentEditable>
      </div>
    </div>
  )
}
